<div class="loader-wrap" *ngIf="show">
	<div class="spinner-wrap">
		<div class="spinner-bg">
			<img class="spinner" [src]="cdnPath + '/assets/images/lu-spinner.gif'" [alt]="'loading' | translate" />
		</div>
	</div>
</div>
